import {AbstractApiResponseInterceptor} from 'core/abstract/AbstractApiResponseInterceptor';
import {isBrowserContext} from 'core/helpers';
import {getRequestId} from 'core/modules/request-id';
import {IHttpClientResponse} from 'core/types';

/* eslint-disable no-console */

export class NodeConsoleResponseLoggerInterceptor extends AbstractApiResponseInterceptor {
    public async intercept(response: IHttpClientResponse, requestOptions: RequestInit): Promise<IHttpClientResponse> {
        if (isBrowserContext()) {
            return response;
        }

        const {raw} = response;

        const requestId = getRequestId();
        const requestIdLabel = requestId ? ` :: request_id: ${requestId}` : '';

        console.group(`[SSR] ${raw.url} :: [${requestOptions.method ?? 'GET'}] [${response.status}]${requestIdLabel}`);

        if (!raw.ok) {
            console.groupEnd();
            return response;
        }

        try {
            const json = await raw.clone().json();
            console.log(json);
            console.groupEnd();
        } catch (e) {
            console.groupEnd();
        }

        console.groupEnd();
        return response;
    }
}
